/* ========================================
   Modello 431 - Complete Form Data
   Based on "Modello unico per attivazione
   ADI - RSA – Riabilitazione Territoriale"
   ASL Roma 5 - Regione Lazio
   ======================================== */

// Full Modello 431 data for each patient
export const modello431Data = {
  1: {
    // SEZIONE 1: DATI ANAGRAFICI
    anagrafica: {
      cognome: "Rossi",
      nome: "Maria",
      luogoNascita: "Roma",
      dataNascita: "02/04/1955",
      via: "Via Roma",
      civico: "45",
      codiceFiscale: "RSSMRA55D42H501B",
      telefono: "+39 06 7654321",
      comuneResidenza: "Roma",
      cap: "00185",
      municipio: "V",
      domicilio: "",
    },
    personaRiferimento: {
      relazione: "Figlio",
      cognome: "Rossi",
      nome: "Luigi",
      telefono: "+39 333 1234567",
    },
    mmg: {
      cognome: "Bianchi",
      nome: "Alessandro",
      distretto: "ASL Roma 2 - Distretto 5",
    },
    provenienza: "mmg", // mmg | ospedale | struttura | altro

    // SEZIONE 2: VALUTAZIONE SANITARIA
    diagnosi: {
      principale: "Diabete Mellito Tipo 2 con complicanze vascolari periferiche e neuropatia diabetica. Ulcera trofica piede destro.",
      concomitanti: "Ipertensione arteriosa stadio II, Obesità di grado I (BMI 32.4), Dislipidemia mista.",
      codiciICD9: "250.00, 357.2, 401.9, 278.00",
    },
    eventoAcuto90gg: true,
    trasportabile: false,
    condizioniCliniche: {
      insufficienzaRespiratoria: false,
      diabete: true,
      cardiopatia: false,
      insufficienzaCardiaca: false,
      malattieVascolari: true,
      esitiPatologieOrtopediche: false,
      malattieOsteomuscolari: false,
      epatopatieNonAlcoliche: false,
      epatopatieAlcoliche: false,
      esitiFratturaFemore: false,
      neurologiche: true,
      malattiaPsichiatrica: false,
      esitiIctus: false,
      demenza: false,
      altreMalInfantili: false,
      disturboGenSviluppo: false,
      disturbiSensoriali: false,
      disabilitaIntellettiva: false,
      paralisiCerebrale: false,
      neoplasie: false,
      neoplasieLocoregionale: false,
      neoplasieMetastatica: false,
      neoplasieCachessia: false,
      altro: false,
      altroSpecifica: "",
    },
    terapiaInAtto: "Metformina 1000mg x 2/die, Insulina Glargine 20UI sera, Ramipril 5mg/die, Amlodipina 5mg/die, Atorvastatina 20mg/die, ASA 100mg/die, Gabapentin 300mg x 3/die",

    // CONDIZIONI CLINICHE ATTUALI
    stabilitaClinica: "moderatamente_instabile", // stabile | moderatamente_instabile | instabile
    statoCoscienza: "lucido", // lucido | orientato_spazio | orientato_tempo | confuso | soporoso | coma
    disturbiCognitivi: "lievi", // assenti | lievi | moderati | gravi
    disturbiComportamentali: "assenti", // assenti | lievi | moderati | gravi
    dolore: 4, // 0-10
    mobilita: "aiuto_persona", // indipendente | aiuto_persona | totalmente_dipendente
    alimentazione: "autonoma", // autonoma | assistito | rifiuta | artificiale
    supportoSociale: "con_figli", // solo | coniuge | figli | genitori | altri
    assistitoDa: "familiari", // familiari | altre_persone

    // SEZIONE 3: NECESSITÀ ASSISTENZIALI
    trattamentiProcedure: {
      chemioRadioterapia: false,
      ossigenoterapiaOLT: false,
      ventilazioneMeccanica: false,
      tracheostomia: false,
      broncoaspirazione: false,
      drenaggioPosturale: false,
      dialisi: false,
      trasfusioniPeriodiche: false,
    },
    somministrazioneFarmaci: {
      nutrizioneParenterale: false,
      nutrizioneEnteraleSNG: false,
      nutrizioneEnteralePEG: false,
      catetereVescicale: false,
      catetereVescicalePermanenza: false,
      catetereVescicaleIntermittenza: false,
      catetereSovrapubico: false,
      uretronefrostomia: false,
      cvcPicc: false,
      catetereEpidurale: false,
      drenaggi: false,
      enterostomia: false,
      ulcereCutanee: true,
      terapiaInfusionale: false,
      ecgPeriodici: true,
      prelieviEmatici: true,
    },
    frequenzaPrelieviECG: "quindicinale", // settimanale | quindicinale | mensile
    accessiMMG: "Settimanale",
    visiteSpecialistiche: "Diabetologo mensile, Chirurgo vascolare quindicinale",
    altroNecessita: "",

    // SEZIONE 4: PERCORSO ASSISTENZIALE
    percorsoRichiesto: "adi", // riab_residenziale | riab_semiresidenziale | riab_domiciliare | adi | rsa
    finalitaObiettivi: {
      stabilizzazionePrevenzione: true,
      monitoraggioClinico: true,
      recuperoFunzioni: false,
      prevenzioneAnchilosi: false,
      sviluppoStrategieCompensatorie: false,
      educazioneProtesiAusili: false,
      altro: true,
      altroSpecifica: "Gestione ulcera trofica e prevenzione amputazione",
    },
    tipologiaAssistenza: ["infermieristica", "specialistica"],
    urgenza: "alta", // alta (U-A 24h) | media (U-B 72h) | bassa (U-C 10gg)

    // COMPILATORE
    compilatore: {
      ruolo: "mmg", // mmg | ospedaliero | specialista
      cognome: "Conti",
      nome: "Paolo",
      telefono: "+39 06 5551234",
      email: "p.conti@aslroma2.it",
      ospedale: "",
      reparto: "",
      data: "15/01/2026",
    },

    // Condizione abitativa (extra from requirements)
    condizioneAbitativa: "parzialmente_idonea", // idonea | parzialmente_idonea | non_idonea
    barriereArchitettoniche: "Appartamento al 3° piano senza ascensore. Bagno non attrezzato per disabili.",

    // Scala ADL semplificata per richiesta
    scalaADL: {
      allettato: false,
      spostaCarrozzina: false,
      deambulaConAiuto: true,
      confusoDisorientato: false,
    },
  },

  // Patient 2
  2: {
    anagrafica: {
      cognome: "Bianchi",
      nome: "Giuseppe",
      luogoNascita: "Napoli",
      dataNascita: "15/01/1948",
      via: "Viale Europa",
      civico: "112",
      codiceFiscale: "BNCGPP48A15F205X",
      telefono: "+39 06 9876543",
      comuneResidenza: "Roma",
      cap: "00144",
      municipio: "IX",
      domicilio: "",
    },
    personaRiferimento: {
      relazione: "Moglie",
      cognome: "Bianchi",
      nome: "Anna",
      telefono: "+39 338 9876543",
    },
    mmg: {
      cognome: "Rizzo",
      nome: "Marco",
      distretto: "ASL Roma 2 - Distretto 7",
    },
    provenienza: "ospedale",
    diagnosi: {
      principale: "Insufficienza cardiaca congestizia (Classe NYHA III) con scompenso acuto recente. Ipertensione arteriosa non controllata.",
      concomitanti: "Fibrillazione atriale permanente, Insufficienza renale cronica stadio IIIa, Anemia normocitica.",
      codiciICD9: "428.0, 401.9, 427.31, 585.3",
    },
    eventoAcuto90gg: true,
    trasportabile: false,
    condizioniCliniche: {
      insufficienzaRespiratoria: true,
      diabete: false,
      cardiopatia: true,
      insufficienzaCardiaca: true,
      malattieVascolari: true,
      esitiPatologieOrtopediche: false,
      malattieOsteomuscolari: false,
      epatopatieNonAlcoliche: false,
      epatopatieAlcoliche: false,
      esitiFratturaFemore: false,
      neurologiche: false,
      malattiaPsichiatrica: false,
      esitiIctus: false,
      demenza: false,
      altreMalInfantili: false,
      disturboGenSviluppo: false,
      disturbiSensoriali: false,
      disabilitaIntellettiva: false,
      paralisiCerebrale: false,
      neoplasie: false,
      neoplasieLocoregionale: false,
      neoplasieMetastatica: false,
      neoplasieCachessia: false,
      altro: false,
      altroSpecifica: "",
    },
    terapiaInAtto: "Furosemide 50mg/die, Bisoprololo 5mg/die, Ramipril 10mg/die, Spironolattone 25mg/die, Warfarin (INR target 2-3), Digossina 0.125mg/die, Eritropoietina 4000UI/sett",
    stabilitaClinica: "moderatamente_instabile",
    statoCoscienza: "lucido",
    disturbiCognitivi: "assenti",
    disturbiComportamentali: "assenti",
    dolore: 2,
    mobilita: "aiuto_persona",
    alimentazione: "autonoma",
    supportoSociale: "coniuge",
    assistitoDa: "familiari",
    trattamentiProcedure: {
      chemioRadioterapia: false,
      ossigenoterapiaOLT: true,
      ventilazioneMeccanica: false,
      tracheostomia: false,
      broncoaspirazione: false,
      drenaggioPosturale: false,
      dialisi: false,
      trasfusioniPeriodiche: false,
    },
    somministrazioneFarmaci: {
      nutrizioneParenterale: false,
      nutrizioneEnteraleSNG: false,
      nutrizioneEnteralePEG: false,
      catetereVescicale: false,
      catetereVescicalePermanenza: false,
      catetereVescicaleIntermittenza: false,
      catetereSovrapubico: false,
      uretronefrostomia: false,
      cvcPicc: false,
      catetereEpidurale: false,
      drenaggi: false,
      enterostomia: false,
      ulcereCutanee: false,
      terapiaInfusionale: true,
      ecgPeriodici: true,
      prelieviEmatici: true,
    },
    frequenzaPrelieviECG: "settimanale",
    accessiMMG: "Bisettimanale",
    visiteSpecialistiche: "Cardiologo settimanale, Nefrologo mensile",
    altroNecessita: "",
    percorsoRichiesto: "adi",
    finalitaObiettivi: {
      stabilizzazionePrevenzione: true,
      monitoraggioClinico: true,
      recuperoFunzioni: true,
      prevenzioneAnchilosi: false,
      sviluppoStrategieCompensatorie: false,
      educazioneProtesiAusili: false,
      altro: false,
      altroSpecifica: "",
    },
    tipologiaAssistenza: ["infermieristica", "specialistica"],
    urgenza: "media",
    compilatore: {
      ruolo: "ospedaliero",
      cognome: "Ferri",
      nome: "Giulia",
      telefono: "+39 06 5559876",
      email: "g.ferri@sgiov.it",
      ospedale: "Ospedale S. Giovanni",
      reparto: "Cardiologia - UOC",
      data: "16/01/2026",
    },
    condizioneAbitativa: "idonea",
    barriereArchitettoniche: "",
    scalaADL: {
      allettato: false,
      spostaCarrozzina: false,
      deambulaConAiuto: true,
      confusoDisorientato: false,
    },
  },

  4: {
    anagrafica: {
      cognome: "Esposito",
      nome: "Luca",
      luogoNascita: "Roma",
      dataNascita: "12/02/1946",
      via: "Via Appia Nuova",
      civico: "678",
      codiceFiscale: "SPSLCU66B12F839M",
      telefono: "+39 06 3216549",
      comuneResidenza: "Roma",
      cap: "00179",
      municipio: "VII",
      domicilio: "",
    },
    personaRiferimento: {
      relazione: "Figlio",
      cognome: "Esposito",
      nome: "Paolo",
      telefono: "+39 339 3216549",
    },
    mmg: {
      cognome: "Mancini",
      nome: "Stefano",
      distretto: "ASL Roma 2 - Distretto 5",
    },
    provenienza: "ospedale",
    diagnosi: {
      principale: "BPCO riacutizzata con insufficienza respiratoria cronica. Enfisema polmonare bolloso bilaterale.",
      concomitanti: "Cuore polmonare cronico, Ipertensione polmonare moderata, Cachessia.",
      codiciICD9: "491.21, 492.8, 416.9, 416.0",
    },
    eventoAcuto90gg: true,
    trasportabile: false,
    condizioniCliniche: {
      insufficienzaRespiratoria: true,
      diabete: false,
      cardiopatia: true,
      insufficienzaCardiaca: true,
      malattieVascolari: false,
      esitiPatologieOrtopediche: false,
      malattieOsteomuscolari: false,
      epatopatieNonAlcoliche: false,
      epatopatieAlcoliche: false,
      esitiFratturaFemore: false,
      neurologiche: false,
      malattiaPsichiatrica: false,
      esitiIctus: false,
      demenza: false,
      altreMalInfantili: false,
      disturboGenSviluppo: false,
      disturbiSensoriali: false,
      disabilitaIntellettiva: false,
      paralisiCerebrale: false,
      neoplasie: false,
      neoplasieLocoregionale: false,
      neoplasieMetastatica: false,
      neoplasieCachessia: false,
      altro: false,
      altroSpecifica: "",
    },
    terapiaInAtto: "Tiotropio 18mcg/die, Salmeterolo/Fluticasone 50/500mcg x 2/die, Prednisone 12.5mg/die, Furosemide 25mg/die, OLT 2L/min 18h/die, Azitromicina 500mg 3gg/sett",
    stabilitaClinica: "instabile",
    statoCoscienza: "lucido",
    disturbiCognitivi: "assenti",
    disturbiComportamentali: "assenti",
    dolore: 3,
    mobilita: "totalmente_dipendente",
    alimentazione: "assistito",
    supportoSociale: "con_figli",
    assistitoDa: "familiari",
    trattamentiProcedure: {
      chemioRadioterapia: false,
      ossigenoterapiaOLT: true,
      ventilazioneMeccanica: true,
      tracheostomia: false,
      broncoaspirazione: true,
      drenaggioPosturale: true,
      dialisi: false,
      trasfusioniPeriodiche: false,
    },
    somministrazioneFarmaci: {
      nutrizioneParenterale: false,
      nutrizioneEnteraleSNG: false,
      nutrizioneEnteralePEG: false,
      catetereVescicale: true,
      catetereVescicalePermanenza: true,
      catetereVescicaleIntermittenza: false,
      catetereSovrapubico: false,
      uretronefrostomia: false,
      cvcPicc: true,
      catetereEpidurale: false,
      drenaggi: false,
      enterostomia: false,
      ulcereCutanee: true,
      terapiaInfusionale: true,
      ecgPeriodici: true,
      prelieviEmatici: true,
    },
    frequenzaPrelieviECG: "settimanale",
    accessiMMG: "Giornaliero",
    visiteSpecialistiche: "Pneumologo bisettimanale",
    altroNecessita: "Ventilazione non invasiva (NIV) notturna. Saturimetria continua.",
    percorsoRichiesto: "adi",
    finalitaObiettivi: {
      stabilizzazionePrevenzione: true,
      monitoraggioClinico: true,
      recuperoFunzioni: false,
      prevenzioneAnchilosi: true,
      sviluppoStrategieCompensatorie: false,
      educazioneProtesiAusili: false,
      altro: true,
      altroSpecifica: "Prevenzione riacutizzazioni e gestione ventilazione domiciliare",
    },
    tipologiaAssistenza: ["infermieristica", "riabilitativa", "specialistica", "oss"],
    urgenza: "alta",
    compilatore: {
      ruolo: "ospedaliero",
      cognome: "Greco",
      nome: "Antonio",
      telefono: "+39 06 5557890",
      email: "a.greco@torvergata.it",
      ospedale: "Policlinico Tor Vergata",
      reparto: "Pneumologia - UOC",
      data: "17/01/2026",
    },
    condizioneAbitativa: "parzialmente_idonea",
    barriereArchitettoniche: "Piano terra. Necessario spazio per concentratore ossigeno e ventilatore.",
    scalaADL: {
      allettato: true,
      spostaCarrozzina: false,
      deambulaConAiuto: false,
      confusoDisorientato: false,
    },
  },
};

// Generate a default/fallback Modello 431 from existing patient data
export function getModello431(patientId, patient) {
  if (modello431Data[patientId]) {
    return modello431Data[patientId];
  }
  // Fallback: generate from basic patient data
  return {
    anagrafica: {
      cognome: patient.cognome,
      nome: patient.nome,
      luogoNascita: "Roma",
      dataNascita: patient.dataNascita,
      via: patient.indirizzo?.split(',')[0] || "",
      civico: "",
      codiceFiscale: patient.codiceFiscale,
      telefono: patient.telefono,
      comuneResidenza: patient.comune || "Roma",
      cap: patient.cap || "",
      municipio: "",
      domicilio: "",
    },
    personaRiferimento: {
      relazione: patient.caregiver?.relazione || "",
      cognome: patient.caregiver?.nome?.split(' ').slice(-1)[0] || "",
      nome: patient.caregiver?.nome?.split(' ')[0] || "",
      telefono: patient.caregiver?.telefono || "",
    },
    mmg: {
      cognome: patient.mmg?.split(' ').slice(-1)[0] || "",
      nome: patient.mmg?.replace('Dr. ', '').replace('Dr.ssa ', '').split(' ')[0] || "",
      distretto: patient.distretto || "",
    },
    provenienza: patient.provenienza === "PUA" ? "mmg" : "ospedale",
    diagnosi: {
      principale: patient.diagnosiPrincipale || "",
      concomitanti: patient.diagnosiSecondaria || "",
      codiciICD9: "",
    },
    eventoAcuto90gg: false,
    trasportabile: true,
    condizioniCliniche: {
      insufficienzaRespiratoria: false, diabete: false, cardiopatia: false,
      insufficienzaCardiaca: false, malattieVascolari: false, esitiPatologieOrtopediche: false,
      malattieOsteomuscolari: false, epatopatieNonAlcoliche: false, epatopatieAlcoliche: false,
      esitiFratturaFemore: false, neurologiche: false, malattiaPsichiatrica: false,
      esitiIctus: false, demenza: false, altreMalInfantili: false,
      disturboGenSviluppo: false, disturbiSensoriali: false, disabilitaIntellettiva: false,
      paralisiCerebrale: false, neoplasie: false, neoplasieLocoregionale: false,
      neoplasieMetastatica: false, neoplasieCachessia: false, altro: false, altroSpecifica: "",
    },
    terapiaInAtto: "",
    stabilitaClinica: "stabile",
    statoCoscienza: "lucido",
    disturbiCognitivi: "assenti",
    disturbiComportamentali: "assenti",
    dolore: 0,
    mobilita: "indipendente",
    alimentazione: "autonoma",
    supportoSociale: "con_figli",
    assistitoDa: "familiari",
    trattamentiProcedure: {
      chemioRadioterapia: false, ossigenoterapiaOLT: false, ventilazioneMeccanica: false,
      tracheostomia: false, broncoaspirazione: false, drenaggioPosturale: false,
      dialisi: false, trasfusioniPeriodiche: false,
    },
    somministrazioneFarmaci: {
      nutrizioneParenterale: false, nutrizioneEnteraleSNG: false, nutrizioneEnteralePEG: false,
      catetereVescicale: false, catetereVescicalePermanenza: false, catetereVescicaleIntermittenza: false,
      catetereSovrapubico: false, uretronefrostomia: false, cvcPicc: false,
      catetereEpidurale: false, drenaggi: false, enterostomia: false,
      ulcereCutanee: false, terapiaInfusionale: false, ecgPeriodici: false, prelieviEmatici: false,
    },
    frequenzaPrelieviECG: "",
    accessiMMG: "",
    visiteSpecialistiche: "",
    altroNecessita: "",
    percorsoRichiesto: "adi",
    finalitaObiettivi: {
      stabilizzazionePrevenzione: false, monitoraggioClinico: false, recuperoFunzioni: false,
      prevenzioneAnchilosi: false, sviluppoStrategieCompensatorie: false,
      educazioneProtesiAusili: false, altro: false, altroSpecifica: "",
    },
    tipologiaAssistenza: [],
    urgenza: patient.priorita || "bassa",
    compilatore: {
      ruolo: "mmg", cognome: "", nome: "", telefono: "", email: "",
      ospedale: "", reparto: "", data: patient.dataRichiesta || "",
    },
    condizioneAbitativa: "idonea",
    barriereArchitettoniche: "",
    scalaADL: {
      allettato: false, spostaCarrozzina: false, deambulaConAiuto: false, confusoDisorientato: false,
    },
  };
}
